import { LucideIcon, Inbox } from 'lucide-react';
import { ReactNode } from 'react';

interface Props {
  icon?: LucideIcon;
  title: string;
  description?: string;
  // Optional primary CTA — usually a "Create new" button
  action?: ReactNode;
  // Optional secondary helper text below the action
  helperText?: string;
  className?: string;
}

/**
 * Empty state for "no data yet" scenarios. Distinct from "no results
 * for your filter" — that case should use a more compact variant. Used
 * on first-time lists across the app (no leads, no users, no webhooks,
 * etc.) so new tenants always have a clear next action.
 */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  helperText,
  className = '',
}: Props) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-16 px-6 ${className}`}>
      <div className="h-14 w-14 rounded-full bg-indigo-50 flex items-center justify-center mb-4">
        <Icon className="h-6 w-6 text-[#6366F1]" />
      </div>
      <h3 className="text-base font-semibold text-slate-900 mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-slate-500 max-w-sm mb-4">{description}</p>
      )}
      {action && <div className="mt-1">{action}</div>}
      {helperText && (
        <p className="text-xs text-slate-400 mt-3 max-w-sm">{helperText}</p>
      )}
    </div>
  );
}
